import React from 'react';
import bindAll from 'lodash.bindall';
import { Box } from "@chakra-ui/layout";
// import Box from '../components/box/box.jsx';
import connectBtnsIcon from './assets/icon--connect.svg';
import './connection.css';
import IconButton from '../components/icon-button/icon-button';
// import VM from 'scratch-vm';
import UsbBtn from './usb-btn.jsx';
import BleBtn from './ble-btn.jsx';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
// import {setisConnected} from '../reducers/connection-modal';
import {isScratchDesktop} from '../lib/isScratchDesktop.js';
import {isWebview} from '../lib/supported-browser.js';
import { setConnectState, setConnectionMode } from '../store/connect-state'
// import {openConnectionModal} from '../reducers/modals';
import {
    injectIntl,
    // intlShape
} from 'react-intl';
import {ExclamationCircleFilled} from '@ant-design/icons';
import {Modal} from 'antd';

const {confirm} = Modal;

class ConnectBtns extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleClick']);
        this.state = {
            show: false
        };
    }

    get isScratchDesktop (){
        return isScratchDesktop();
    }

    componentDidMount () {
        // console.log(window.peripheral.isConnected(), 'window.peripheral.isConnected()')
        // this.props.vm.on('PERIPHERAL_CONNECTED', this.props.onConneted);
        // this.props.vm.on('PERIPHERAL_DISCONNECTED', this.props.onDisConnected);
        // this.props.vm.on('PERIPHERAL_CONNECTION_LOST_ERROR', this.props.onDisConnected);
        // this.props.vm.on('CONNECT_READY', this.props.openConnectionDialog);
    }

    componentDidUpdate (preProps) {
        if (preProps.isConnected === true && this.props.isConnected === false) {
            // console.log('preProps.isConnected', preProps.isConnected, '现在的链接状态：', this.props.isConnected);
            this.setState({
                show: false
            });
        }
    }

    componentWillUnmount () {
        // this.props.vm.removeListener('PERIPHERAL_CONNECTED', this.props.onConneted);
        // this.props.vm.removeListener('PERIPHERAL_DISCONNECTED', this.props.onDisConnected);
        // this.props.vm.removeListener('PERIPHERAL_CONNECTION_LOST_ERROR', this.props.onDisConnected);
        // this.props.vm.removeListener('CONNECT_READY', this.props.openConnectionDialog);
    }

    handleClick () {
        // console.log('isScratchDesktop',isScratchDesktop());
        this.setState({
            show: !this.state.show
        });
        if (typeof navigator.bluetooth === 'undefined') {
            this.showSupportTips();
        }
    }

    showSupportTips = () => {
        confirm({
            title: this.props.intl.formatMessage({
                defaultMessage: 'Browser Compatibility Issue',
                description: 'Browser Compatibility Issue',
                id: 'gui.browser.title'
            }),
            icon: <ExclamationCircleFilled />,
            centered: true,
            content: this.props.intl.formatMessage({
                defaultMessage: 'Your current browser doesn\'t support device connections. To establish device connections, please use the latest version of Google Chrome.',
                description: 'Browser compatibility message',
                id: 'gui.browser.content'
            }),
            okText: this.props.intl.formatMessage({
                defaultMessage: 'OK',
                description: 'OK',
                id: 'gui.prompt.ok'
            }),
            cancelText: this.props.intl.formatMessage({
                defaultMessage: 'Cancel',
                description: 'Cancel',
                id: 'gui.prompt.cancel'
            }),
            onOk () {
                // You can remove the `onOk` callback, or leave it empty if not needed.
            }
        });
    };

    render () {
        if (this.props.isConnected && this.props.mode === 'ble') {
            return (
                <BleBtn
                    // vm={this.props.vm}
                    show
                />
            );
        }else if (this.props.isConnected && this.props.mode === 'usb') {
            return (<UsbBtn
                // vm={this.props.vm}
                show
            />);
        }
        return (
            <>
                <Box>
                    <IconButton
                        className="connectBtns"
                        img={connectBtnsIcon}
                        onClick={this.handleClick}
                    />
                </Box>
                {
                    this.isScratchDesktop || isWebview() ? null : <UsbBtn
                        // vm={this.props.vm}
                        show={this.state.show}
                    />
                }
                <BleBtn
                    // vm={this.props.vm}
                    show={this.state.show}
                />
            </>
        );
    }
}

ConnectBtns.propTypes = {
    // vm: PropTypes.instanceOf(VM).isRequired,
    isConnected: PropTypes.bool,
    mode: PropTypes.string,
    // intl: intlShape.isRequired
};

const mapStateToProps = state => ({
    // vm: state.scratchGui.vm,
    mode: state.connectStore.mode,
    isConnected: state.connectStore.isConnected
});

const mapDispatchToProps = dispatch => ({
    openConnectionDialog: () => {
        // dispatch(openConnectionModal());
    },
    onConneted: () => {
        // console.log('链接成功')
        dispatch(setConnectState(true));
    },
    onDisConnected: () => {
        // console.log('断开链接');
        dispatch(setConnectState(false));
    }
});

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(
    ConnectBtns
);
